module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    attrs: {
      "app": "",
      "fixed": "",
      "color": "white",
      "clipped-left": _vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('v-toolbar-items', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "no-padding no-highlight no-caps",
    attrs: {
      "slot": "activator",
      "flat": "",
      "target": "_blank",
      "href": "https://www.gunghoprinting.com/"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "toolbar-logo",
    attrs: {
      "src": "https://assets.gungho.com/gung-ho-logo.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "pb-1 hidden-sm-and-down"
  }, [_c('span', {
    staticClass: "start"
  }, [_vm._v("Gung-Ho")]), _c('span', {
    staticClass: "middle"
  }, [_vm._v("Printing")]), _c('span', {
    staticClass: "end"
  }, [_vm._v(".com")])])], 1), _vm._v(" "), _c('span', [_vm._v("Gung-HoPrinting.com Home Page")])], 1), _vm._v(" "), _c('v-tooltip', {
    staticClass: "ml-5",
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "icon-only gh-blue hidden-sm-and-down",
    attrs: {
      "slot": "activator",
      "flat": "",
      "target": "_blank",
      "href": (_vm.contactUrl + "?sub=Technical Support / Report A Bug")
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("mdi-bug")]), _vm._v(" Report A Bug\n      ")], 1), _vm._v(" "), _c('span', [_vm._v("Send Bug Report to Gung-Ho")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('create-menu'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "slot": "activator",
      "flat": "",
      "to": "/items"
    },
    slot: "activator"
  }, [_vm._v("\n        Items\n      ")]), _vm._v(" "), _c('span', [_vm._v("Review Items / Reprint One Or More Items")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "slot": "activator",
      "flat": "",
      "to": "/orders"
    },
    slot: "activator"
  }, [_vm._v("\n        Orders\n      ")]), _vm._v(" "), _c('span', [_vm._v("Review Orders / Reprint An Entire Order")])], 1), _vm._v(" "), _c('v-tooltip', {
    staticClass: "ml-5 hidden-sm-and-down",
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "icon-only",
    attrs: {
      "slot": "activator",
      "flat": "",
      "target": "_blank",
      "href": _vm.helpUrl
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("mdi-help-circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Help Topics & Customer Support")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "icon-only",
    attrs: {
      "slot": "activator",
      "flat": "",
      "to": "/checkout"
    },
    slot: "activator"
  }, [_c('v-badge', {
    staticClass: "small",
    attrs: {
      "right": "",
      "overlap": ""
    }
  }, [(_vm.cartCount > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.cartCount))]) : _vm._e(), _vm._v(" "), _c('v-icon', [_vm._v("mdi-cart")])], 1)], 1), _vm._v(" "), _c('span', [_vm._v("Proceed to Checkout")])], 1), _vm._v(" "), _c('profile-menu')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21de7262","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/header-menu.vue
// module id = 801
// module chunks = 1